import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import { logout } from "../auth/authSlice";
// import {
//   disconnectInstagramApi,
//   getAllPacksForBrandCall,
//   getSingleCreatorCall,
//   sendCollaborationCall,
// } from "../../Common/Repository";

import { getAllPacksForBrandCall } from "actions/packAction";
import { disconnectInstagramCall, getSingleCreatorCall, sendCollaborationCall } from "actions/creatorAction";

const initialState = {
  loading: false,
  instagramLoading: false,
  disconnectInstagramLoading: false,
  disconnectSuccessful: false,
  inviteLoading: false,
  isFavourite: false,
  error: null,
  success: false,
  creatorsCollaborationData: [],
  instagramData: {},
  singleCreator: {},
  reviewsReceived: [],
  averageRating: null,
  reviewCount: 0,
  creatorPacksData: [],
  creatorDetailsPacksCurrentPage: 1,
  creatorDetailsPacksTotalPages: 0,
  packsLoading: false,
};

const creatorDetailsSlice = createSlice({
  name: "creatorDetails",
  initialState,
  reducers: {
    setCreatorDetailsPacksCurrentPage: (state, action) => {
      state.creatorDetailsPacksCurrentPage = action?.payload;
    },
    setCreatorsCollaborationData: (state, action) => {
      state.creatorsCollaborationData = action.payload;
    },
    setInstagramData: (state, action) => {
      state.instagramData = action.payload
    },
    setInstagramSuccessFalse: (state, action) => {
      state.disconnectSuccessful = false;
    },
    setSingleCreatorData: (state, action) => {
      state.singleCreator = action.payload;
      state.isFavourite =
        state.singleCreator?.favourite_creator?.is_favourite === 1 ||
        state.singleCreator?.favourite_creator?.is_favourite === "1";
      state.instagramLoading = false;
    },
    setReviewsReceived: (state, action) => {
      state.reviewsReceived = action.payload;
    },
    setAverageReviewRating: (state, action) => {
      state.averageRating = action?.payload;
    },
    setTotalReviewCount: (state, action) => {
      state.reviewCount = action?.payload;
    },
    setCreatorPacksData: (state, action) => {
      state.creatorPacksData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setFavourite: (state, action) => {
      state.isFavourite = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendCollaborationCall.pending, (state) => {
        state.inviteLoading = true;
        state.error = null;
      })
      .addCase(sendCollaborationCall.fulfilled, (state, action) => {
        state.inviteLoading = false;
        state.error = null;

        // const newCollab = action.payload?.data?.collaboration;
        // if (newCollab) {
        //   if (!Array.isArray(state.creatorsCollaborationData)) {
        //     state.creatorsCollaborationData = [];
        //   }

        //   state.creatorsCollaborationData.push({
        //     ...newCollab,
        //     status: "pending",
        //   });
        // }
        // document.getElementById("invite-modal-close").click();
        // toast.success("Collaboration Request Sent Successfully!");
      })
      .addCase(sendCollaborationCall.rejected, (state, action) => {
        state.inviteLoading = false;
        state.error = action.payload; 
      })
      .addCase(getSingleCreatorCall.pending, (state) => {
        state.error = null;
        state.instagramLoading = true;
      })
      .addCase(getSingleCreatorCall.fulfilled, (state, action) => {
        state.creatorsCollaborationData = action.payload?.collaborations;
        state.averageRating = action?.payload?.data?.average_rating;
        state.reviewCount = action?.payload?.data?.total_reviews;
        state.loading = false;
        state.instagramLoading = false;
        state.error = null;
      })
      .addCase(getSingleCreatorCall.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        //
        state.singleCreator = null;
      })
      .addCase(getAllPacksForBrandCall.pending, (state) => {
        state.packsLoading = true;
        state.error = null;
      })
      .addCase(getAllPacksForBrandCall.fulfilled, (state, action) => {
        state.creatorPacksData = action.payload?.data?.data?.data;
        state.creatorDetailsPacksCurrentPage = action?.payload?.data?.data?.current_page;
        state.creatorDetailsPacksTotalPages = action?.payload?.data?.data?.last_page;

        state.packsLoading = false;
        state.error = null;
      })
      .addCase(getAllPacksForBrandCall.rejected, (state, action) => {
        state.packsLoading = false;
        state.error = action.payload;
      })
      .addCase(disconnectInstagramCall.pending, (state) => {
        state.disconnectInstagramLoading = true;
      })
      .addCase(disconnectInstagramCall.fulfilled, (state, action) => {
        toast.success(action?.payload?.data?.message);
        state.disconnectInstagramLoading = false;
        state.disconnectSuccessful = true;
      })
      .addCase(disconnectInstagramCall.rejected, (state, action) => {
        state.disconnectInstagramLoading = false;
        state.disconnectSuccessful = false;
      })
      .addCase(logout, (state) => {
        return initialState;
      });
  },
});

export const {
  setInstagramSuccessFalse,
  setCreatorsCollaborationData,
  setCreatorDetailsPacksCurrentPage,
  setSingleCreatorData,
  setInstagramData,
  setReviewsReceived,
  setCreatorPacksData,
  setTotalReviewCount,
  setAverageReviewRating,
  setLoading,
  setFavourite,
} = creatorDetailsSlice.actions;
export default creatorDetailsSlice.reducer;
